import Vue from 'vue'
import VueRouter from 'vue-router'
/*import Index from '@/views/Index.vue'
import Regist from '@/views/Regist.vue'
import Pay from '@/views/Pay.vue'
import Riches from '@/views/Riches.vue'
import Recharge from '@/views/Recharge.vue'
import Withdrawals from '@/views/Withdrawals.vue'
import Bind from '@/views/Bind.vue'
import Transactions from '@/views/Transactions.vue'
import PayRedirect from '@/views/PayRedirect.vue'
import BalanceRecord from '@/views/BalanceRecord.vue'*/

const Index = () => import(/* webpackChunkName: "Index" */ '@/views/Index.vue')
const Regist = () => import(/* webpackChunkName: "Regist" */ '@/views/Regist.vue')
const PayRedirect = () => import(/* webpackChunkName: "PayRedirect" */ '@/views/PayRedirect.vue')
const Pay = () => import(/* webpackChunkName: "Pay" */ '@/views/Pay.vue')
const Riches = () => import(/* webpackChunkName: "Riches" */ '@/views/Riches.vue')
const Recharge = () => import(/* webpackChunkName: "Recharge" */ '@/views/Recharge.vue')
const Withdrawals = () => import(/* webpackChunkName: "Withdrawals" */ '@/views/Withdrawals.vue')
const Transactions = () => import(/* webpackChunkName: "Transactions" */ '@/views/Transactions.vue')
const BalanceRecord = () => import(/* webpackChunkName: "BalanceRecord" */ '@/views/BalanceRecord.vue')
const TradeDetails = () => import(/* webpackChunkName: "TradeDetails" */ '@/views/TradeDetails.vue')
const BalanceDetails = () => import(/* webpackChunkName: "BalanceDetails" */ '@/views/BalanceDetails.vue')
const Transfer = () => import(/* webpackChunkName: "Transfer" */ '@/views/Transfer.vue')
const LoginRedirect = () => import(/* webpackChunkName: "LoginRedirect" */ '@/views/LoginRedirect.vue')
const InitPayPassword = () => import(/* webpackChunkName: "InitPayPassword" */ '@/views/InitPayPassword.vue')
const PayForward = () => import(/* webpackChunkName: "PayForward" */ '@/views/PayForward.vue')
const User = () => import(/* webpackChunkName: "User" */ '@/views/User.vue')
const UserInfo = () => import(/* webpackChunkName: "User" */ '@/components/user/Info.vue')
const UserAddress = () => import(/* webpackChunkName: "User" */ '@/components/user/Address.vue')
const UserSafety = () => import(/* webpackChunkName: "User" */ '@/components/user/Safety.vue')
const UserBind = () => import(/* webpackChunkName: "User" */ '@/components/user/Bind.vue')
const UserMsg = () => import(/* webpackChunkName: "User" */ '@/components/user/Msg.vue')
const ResetPassword = () => import(/* webpackChunkName: "User" */ '@/components/user/ResetPassword.vue')
const ResetPayPassword = () => import(/* webpackChunkName: "User" */ '@/components/user/ResetPayPassword.vue')
const ResetTel = () => import(/* webpackChunkName: "User" */ '@/components/user/ResetTel.vue')
const ResetEmail = () => import(/* webpackChunkName: "User" */ '@/components/user/ResetEmail.vue')


// const Img = () => import(/* webpackChunkName: "main" */ '@/components/Img.vue')
Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'Index',
    meta: {
      showHead: true,
      auth: false
    },
    component: Index
  },
  {
    path: '/regist',
    name: 'Regist',
    meta: {
      showHead: false,
      auth: false
    },
    component: Regist
  },
  {
    path: '/payRedirect',
    name: 'PayRedirect',
    meta: {
      showHead: false,
      auth: false
    },
    component: PayRedirect
  },
  {
    path: '/pay',
    name: 'Pay',
    meta: {
      showHead: false,
      auth: true
    },
    component: Pay
  },
  {
    path: '/riches',
    name: 'Riches',
    meta: {
      showHead: true,
      auth: true
    },
    component: Riches
  },
  {
    path: '/recharge',
    name: 'Recharge',
    meta: {
      showHead: false,
      auth: true
    },
    component: Recharge
  },
  {
    path: '/withdrawals',
    name: 'Withdrawals',
    meta: {
      showHead: false,
      auth: true
    },
    component: Withdrawals
  },
  {
    path: '/transactions',
    name: 'Transactions',
    meta: {
      showHead: true,
      auth: true
    },
    component: Transactions
  },
  {
    path: '/balanceRecord',
    name: 'BalanceRecord',
    meta: {
      showHead: true,
      auth: true
    },
    component: BalanceRecord
  },
  {
    path: '/tradeDetails',
    name: 'TradeDetails',
    meta: {
      showHead: true,
      auth: true
    },
    component: TradeDetails
  },
  {
    path: '/balanceDetails',
    name: 'BalanceDetails',
    meta: {
      showHead: true,
      auth: true
    },
    component: BalanceDetails
  },
  {
    path: '/transfer',
    name: 'Transfer',
    meta: {
      showHead: false,
      auth: true
    },
    component: Transfer
  },
  {
    path: '/loginRedirect',
    name: 'LoginRedirect',
    meta: {
      showHead: false,
      auth: false
    },
    component: LoginRedirect
  },
  {
    path: '/initPayPassword',
    name: 'InitPayPassword',
    meta: {
      showHead: false,
      auth: true
    },
    component: InitPayPassword
  },
  {
    path: '/payForward',
    name: 'PayForward',
    meta: {
      showHead: true,
      auth: true
    },
    component: PayForward
  },
  {
    path: '/user',
    name: 'User',
    redirect: '/user/info',
    meta: {
      showHead: true,
      auth: true
    },
    component: User,
    children: [
      {
        path: '/user/info',
        name: 'UserInfo',
        meta: {
          showHead: true,
          auth: true
        },
        component: UserInfo
      },
      {
        path: '/user/address',
        name: 'UserAddress',
        meta: {
          showHead: true,
          auth: true
        },
        component: UserAddress
      },
      {
        path: '/user/safety',
        name: 'UserSafety',
        meta: {
          showHead: true,
          auth: true
        },
        component: UserSafety
      },
      {
        path: '/user/bind',
        name: 'UserBind',
        meta: {
          showHead: true,
          auth: true
        },
        component: UserBind
      },
      {
        path: '/user/msg',
        name: 'UserMsg',
        meta: {
          showHead: true,
          auth: true
        },
        component: UserMsg
      },
      {
        path: '/user/resetPassword',
        name: 'ResetPassword',
        meta: {
          showHead: true,
          auth: true
        },
        component: ResetPassword
      },
      {
        path: '/user/resetPayPassword',
        name: 'ResetPayPassword',
        meta: {
          showHead: true,
          auth: true
        },
        component: ResetPayPassword
      },
      {
        path: '/user/resetTel',
        name: 'ResetTel',
        meta: {
          showHead: true,
          auth: true
        },
        component: ResetTel
      },
      {
        path: '/user/resetEmail',
        name: 'ResetEmail',
        meta: {
          showHead: true,
          auth: true
        },
        component: ResetEmail
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router